import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  institution: null,
  applicants: null,
  programs:null,
};

const institutionSlice = createSlice({
  name: "institution",
  initialState,
  reducers: {
    setInstitution: (state, { payload }) => {
      state.institution = payload;
    },
    setPrograms: (state, { payload }) => {
      state.programs = payload;
    },
    setInstitutionApplicants: (state, { payload }) => {
      state.applicants = payload;
    },
  },
});
const { actions, reducer } = institutionSlice;

export const { setInstitution, setInstitutionApplicants, setPrograms } = actions;
export default reducer;

// selectors
export const institutionSelector = (state) => state.institution.institution;
export const programsSelector = (state) => state.institution.programs;
export const institutionApplicantsSelector = (state) =>
  state.institution.applicants;
